import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { EventSharedService } from 'src/app/shared/services/event-shared.service';
import { ExecucaoOrcamentaria } from '../../models/execucao-orcamentaria.model';
import { ProjetoCadastro } from '../../models/projeto-cadastro.model';
import { NavigationService } from '../../services/navigation.service';
import { PesquisaGeralService } from '../../services/pesquisa-geral.service';

@Component({
  selector: 'app-detalhe-projeto-execucao-orcamentaria-view',
  templateUrl: './detalhe-projeto-execucao-orcamentaria-view.component.html',
  styleUrls: ['./detalhe-projeto-execucao-orcamentaria-view.component.scss']
})
export class DetalheProjetoExecucaoOrcamentariaViewComponent extends BaseListComponent<ExecucaoOrcamentaria> implements OnInit, OnDestroy {

  activeTab: string = 'configurar';
  idProjeto: number;
  idExecucao: number;
  execucao: ExecucaoOrcamentaria[];
  infoProjeto: ProjetoCadastro;
  permission: any;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private navigation: NavigationService,
    private pesquisaGeralService: PesquisaGeralService,
  ) {
    super()
  }

  ngOnInit(): void {
    this.getQueryPage();
    this.pesquisaGeralService.info.subscribe(info => {
      this.infoProjeto = info;
      this.idProjeto = this.infoProjeto.id;
    });
    
    this.idExecucao = this.activatedRoute.snapshot.params['id'];
    this.permission = this.activatedRoute.snapshot.data['permission'];
    this.addSub(EventSharedService.get('reloadPermission').subscribe((res) => {
      this.permission = res;
      EventSharedService.get('reloadPermissionLoaList').emit(res)
    }))
    this.loaded();
  }

  ngOnDestroy(): void {
    this.unsubscribeList();
  }

  voltar() {
    this.navigation.back(['projetos', 'projeto', this.idProjeto, 'execucao-orcamentaria']);
  }

  getQueryPage(): void{
    this.activatedRoute.queryParams.subscribe(params => {
      if (params) {
        try {
          this.activeTab = params['pagina'] ?? 'configurar';
        } catch (e) {
          console.error('Erro ao aplicar filtro dos query params', e);
        }
      }
    });
  }
  savePageToQueryParams(value: string): void {
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: { 'pagina': value },
      queryParamsHandling: 'merge',
      replaceUrl: true
    });
  }
}
